import { Tab, TabGroup, TabProps, Tag } from '@servicetitan/design-system';
import classNames from 'classnames';
import { FC } from 'react';
import { PortalMode } from '../../../stores/portal.store';
import { keyVal } from '../../../utils/keyval';
import { modeObserver } from '../../mode-observer';
import { ContentBlock } from '../content';
import * as Styles from './content-tab.module.less';

export interface ContentTabProps {
    className?: string;
    mode: PortalMode;
    tabs: {
        title: string;
        count?: number;
        props?: TabProps;
    }[];
    activeIndex?: number;
    onChange?(tabIndex: number): void;
}

export const ContentTab: FC<ContentTabProps> = ({
    activeIndex,
    className,
    mode,
    onChange,
    tabs,
}) => (
    <ContentBlock
        className={classNames({ [Styles.tabMobile]: !mode.desktop }, 'p-y-0-i', className)}
        white
    >
        <TabGroup className={classNames('shadow-0')}>
            {tabs.map((tab, index) => (
                <Tab
                    key={keyVal(tab.title, index)}
                    active={index === activeIndex}
                    onClick={() => onChange?.(index)}
                    {...tab.props}
                >
                    {tab.title}
                    {typeof tab.count === 'number' && (
                        <Tag compact badge>
                            {tab.count}
                        </Tag>
                    )}
                </Tab>
            ))}
        </TabGroup>
    </ContentBlock>
);

export const ContentTabObserver = modeObserver(ContentTab);
